module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iDwJd"))).then(() => parcelRequire('dJXJK'));